"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.KTR = exports.KeepTheRhythmComponent = void 0;
var app_1 = require("app");
var KeepTheRhythmComponent = /** @class */ (function (_super) {
    __extends(KeepTheRhythmComponent, _super);
    function KeepTheRhythmComponent() {
        var _this = _super.call(this) || this;
        // + .ktr-padding if padding instead of margin
        _this.selector = ".ktr, .cta--large, .cta--small, .grid-danf-fe-rte img, .grid-danf-fe-rte table:not([class])";
        _this.skipInitIfNotOnPage = false;
        return _this;
    }
    KeepTheRhythmComponent.prototype.OnInit = function () {
        this.FixTheRhythmElems(this.$el);
    };
    KeepTheRhythmComponent.prototype.OnWindowResizeThrottle = function () {
        this.FixTheRhythmElems(this.$el);
    };
    KeepTheRhythmComponent.prototype.OnInstancesUpdated = function () {
        this.FixTheRhythmElems(this.$el);
    };
    KeepTheRhythmComponent.prototype.GetMissingRhythm = function (height) {
        var rhythm = KeepTheRhythmComponent.baseline - (height % KeepTheRhythmComponent.baseline);
        if (rhythm === KeepTheRhythmComponent.baseline) {
            rhythm = 0;
        }
        return rhythm;
    };
    KeepTheRhythmComponent.prototype.FixTheRhythmElems = function ($el) {
        var _this = this;
        $el.each(function (idx, elem) { return _this.FixTheRhythm($(elem)); });
    };
    KeepTheRhythmComponent.prototype.FixTheRhythm = function ($el) {
        var _this = this;
        if ($el.closest(".no-ktr").length) {
            return;
        }
        var parent = $el.closest("div"), el = parent.hasClass("bordered") ? parent : $el, height = this.GetElementHeight($el);
        var rhythm = this.GetMissingRhythm(height);
        // top aligment
        var top = 0;
        var bottom = rhythm;
        var style = "margin-bottom";
        if (el.hasClass("ktr-padding")) {
            style = "padding-bottom";
        }
        if (el.hasClass("ktr--not_zero")) {
            bottom = (bottom !== 0) ? bottom : KeepTheRhythmComponent.baseline;
        }
        el.css(style, bottom + "px");
        if ($el.is("img") && !$el.prop("complete")) {
            $el.on("load", function () {
                _this.FixTheRhythm($el);
                $el.off("load");
            });
        }
    };
    KeepTheRhythmComponent.prototype.GetElementHeight = function ($el) {
        if ($el.hasClass("ktr-padding")) { // compute height without paddings, border, margins
            return window.getComputedStyle($el[0], null).getPropertyValue("height");
        }
        return $el.outerHeight() || $el.parent().outerHeight() || $el[0].height;
    };
    KeepTheRhythmComponent.baseline = 24;
    return KeepTheRhythmComponent;
}(app_1.Component));
exports.KeepTheRhythmComponent = KeepTheRhythmComponent;
var KTR = new KeepTheRhythmComponent();
exports.KTR = KTR;
